import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

/**
 * PageLayout — shared shell that wraps every page with Navbar + Footer + Floating WhatsApp Contact.
 */
export default function PageLayout({ children }) {
  return (
    <div className="pi">
      <Navbar />
      <main className="page-main">
        {children}
      </main>
      <Footer />

      {/* Floating WhatsApp Quick Connect Button */}
      <a
        href="https://wa.me/9779857074103?text=Namaste%20Laxmikant%20ji%2C%20I%20am%20inquiring%20via%20VivahNepal.com"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        title="Chat with Vivah Nepal on WhatsApp (9857074103)"
        aria-label="Chat with Vivah Nepal on WhatsApp"
      >
        <svg viewBox="0 0 24 24" width="26" height="26" fill="white">
          <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.149.929 3.182 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.771-5.768-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.312.045-.693.078-2.227-.557-1.745-.724-2.885-2.518-2.973-2.635-.088-.116-.708-.941-.708-1.795 0-.855.448-1.274.607-1.448.16-.175.348-.219.465-.219.116 0 .233.002.336.007.107.005.25-.041.391.298.144.348.494 1.202.537 1.29.044.088.073.19.015.305-.058.117-.088.19-.175.292-.087.102-.185.228-.264.306-.088.087-.179.182-.077.357.102.175.454.748.974 1.211.669.596 1.233.78 1.408.868.175.087.277.073.38-.044.102-.116.438-.51.554-.685.117-.175.234-.146.394-.088.16.058 1.02.481 1.195.568.175.088.292.131.336.204.044.073.044.423-.1 1.033z"/>
          <path d="M12 2C6.477 2 2 6.477 2 12c0 1.891.524 3.662 1.435 5.178L2 22l4.981-1.396C8.423 21.503 10.15 22 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18.167c-1.684 0-3.25-.494-4.577-1.344l-.328-.209-2.964.83.829-2.889-.224-.337A8.134 8.134 0 013.833 12c0-4.503 3.664-8.167 8.167-8.167 4.503 0 8.167 3.664 8.167 8.167 0 4.503-3.664 8.167-8.167 8.167z"/>
        </svg>
        <span className="whatsapp-text">Chat on WhatsApp</span>
      </a>
    </div>
  );
}
